import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorTerminate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M6.16 6.11a.75.75 0 0 1 0 1.06 8.25 8.25 0 1 0 11.67 0 .75.75 0 1 1 1.06-1.06 9.75 9.75 0 1 1-13.79 0 .75.75 0 0 1 1.06 0Z"
    />
    <path
      fill="#F7A600"
      d="M12 1.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75Z"
    />
  </svg>
);
export default SvgTwoColorTerminate;
